howspace.components.numberInput = (() => {
    'use strict';

    const handleInput = e => {
        const input = $(e.currentTarget);
        clearTimeout(input.data('debounce-timeout'));
        const debounceTimeout = setTimeout(() => {
            const value = parseInt(input.val());
            const min = parseInt(input.attr('min'));
            const max = parseInt(input.attr('max'));

            if (value < min) {
                input.val(min);
            } else if (value > max) {
                input.val(max);
            }
        }, 500);
        input.data('debounce-timeout', debounceTimeout);
    };

    const handleKeyDown = e => {
        const input = $(e.currentTarget);
        const min = parseInt(input.attr('min'));

        if (real.browser.isFirefox && e.key === ',') {
            e.preventDefault();
        }

        if (!input.data('float')) {
            if (e.key === ',' || e.key === '.') {
                e.preventDefault();
            }
        }

        if ((min >= 0 && e.key === '-') || e.key === 'e' || e.key === '+') {
            e.preventDefault();
        }
    };

    const handleWheel = e => {
        // Only prevent the native number "step" when the input is focused.
        // This avoids breaking normal page scroll when the cursor happens to be over the input.
        if (document.activeElement === e.currentTarget) {
            e.preventDefault();
        }
    };

    const initTooltip = (elem) => {
        const min = parseInt(elem.attr('min'));
        const max = parseInt(elem.attr('max'));

        let title;
        if (min > -Infinity && max < Infinity) {
            title = howspace.translate('common_value_must_be_between', {min: min, max: max});
        } else if (min > -Infinity) {
            title = howspace.translate('common_value_must_be_at_least', {min: min});
        } else if (max < Infinity) {
            title = howspace.translate('common_value_must_be_at_most', {max: max});
        }

        const tooltip = elem.closest('.howspace-form-label').find('.howspace-form-label-text .tooltip');
        howspace.components.toolTip.update(tooltip, title);
    };

    return {
        init: elem => {
            elem.findIncludingSelf('.howspace-form-number-input:not(.howspace-form-number-input-initialized)').each(function () {
                const numberInput = $(this);
                numberInput.addClass('howspace-form-number-input-initialized');

                numberInput.on('input', handleInput);
                numberInput.on('keydown', handleKeyDown);

                // Use non-passive so preventDefault works in modern browsers.
                numberInput[0].addEventListener('wheel', handleWheel, { passive: false });
            });
        },
        destroy: elem => {
            elem.findIncludingSelf('.howspace-form-number-input.howspace-form-number-input-initialized').each(function () {
                const numberInput = $(this);
                numberInput.removeClass('howspace-form-number-input-initialized');

                numberInput.off('input', handleInput);
                numberInput.off('keydown', handleKeyDown);

                numberInput[0].removeEventListener('wheel', handleWheel, { passive: false });
            });
        },
        setMin: (elem, min) => {
            elem.findIncludingSelf('.howspace-form-number-input').each(function () {
                const numberInput = $(this);
                numberInput.prop('min', min);
                initTooltip(numberInput);
            });
        },
        setMax: (elem, max) => {
            elem.findIncludingSelf('.howspace-form-number-input').each(function () {
                const numberInput = $(this);
                numberInput.prop('max', max);
                initTooltip(numberInput);
            });
        }
    };

})();
